import {RestRequestDELETE, RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from 'redux/store'
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";
import validateSection from "./helpers/validateSection";

const getDemandAdditionalInfoWrapper = async (id) => {
    try {
        return RestRequestGET(Endpoints.DEMAND_ADDITIONAL_INFO(id));
    } catch (error) {
    }
}

const saveDemandAdditionalInfo = async (id, data, sectionId) => {
    try {
        const resp = RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_INFO(id), data);
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e))))
            await validateSection(sectionId, id, true);
    } catch (error) {
        console.error(error);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}
const validate = async (id, section) => {
    return RestRequestGET(Endpoints.DEMAND_ADDITIONAL_INFO_VALIDATE(id), {params: {section: section}})
}

const checkForDraft = async (id) => {
    return await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_INFO_AUTOSAVE_CHECK(id));
}

const loadDraft = async (id) => {
    return await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_INFO_AUTOSAVE(id));
}

const saveDraft = async (id, formValues) => {
    await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_INFO_AUTOSAVE(id), formValues);
}

const deleteDraft = async (id) => {
    await RestRequestDELETE(Endpoints.DEMAND_ADDITIONAL_INFO_AUTOSAVE(id));
}

export default {
    getDemandAdditionalInfoWrapper,
    saveDemandAdditionalInfo,
    validate,
    checkForDraft,
    loadDraft,
    saveDraft,
    deleteDraft
}